import { TierType } from '@com-delta-idp/mnx-skymiles-shared';
import { Legends as LegendsUI } from '@com-delta-omnichannel/aura';
import { Legends } from '../../models/aem/overview.interface';

export const getLegends = (tier: TierType, legends: Legends[]): LegendsUI => {
  return {
    tier,
    types: legends.map((legend) => legend.title)
  };
};
